import pt from '../assets/locales/pt.json'
import en from '../assets/locales/en.json'

const locales = { en, pt }

export default locales
